import * as React from "react";
import moment from "moment-timezone";
import {Text, View, TouchableWithoutFeedback} from "react-native";
import {Button} from "../../../../shared/button";
import {Ionicons} from "@expo/vector-icons";
import {PickupRequestItem} from "./my-pickup-requests/pickup-request-item";
import {filter, sortBy} from 'lodash'
import {TransparentBox} from "../../../../ui/transparent-box";

export const MyPickupRequests = ({
                                     items,
                                     onCancelItem
                                 }) => {

    const [scopeDate, setScopeDate] = React.useState(moment().format('YYYY-MM'))
    const isCurrentMonth = moment().format('YYYY-MM') == scopeDate
    const formatedSelectedMonth = isCurrentMonth ? <Text style={{color: '#aac0bf' }}>This month</Text> : <>
        <Text style={{color: '#aac0bf'}}>{moment(`${scopeDate}-01`).format('MMMM YYYY')}</Text>
    </>

    const onNextMonth = () => setScopeDate(moment(`${scopeDate}-01`).add(1, 'month').format('YYYY-MM'))
    const onPrevMonth = () => setScopeDate(moment(`${scopeDate}-01`).subtract(1, 'month').format('YYYY-MM'))

    const filteredItems = sortBy(
        filter(items, item => moment(item.date).add(1, 'second').isBetween(moment(`${scopeDate}-01`), moment(`${scopeDate}-01`).add(1, 'month'))),
        'date'
    )

    return <TransparentBox>
        <View style={{flexDirection: 'column', height: 70, justifyContent: 'space-between', alignItems: 'center'}}>
            <Text style={{fontSize: 16, color: 'white'}}><Text style={{color: '#a0ca45', fontWeight: 'bold'}}>Pick up</Text> requests</Text>
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
                <TouchableWithoutFeedback onPress={onPrevMonth}>
                    <View style={{padding: 5}}>
                        <Ionicons name="ios-arrow-back" size={25} color="white"/>
                    </View>
                </TouchableWithoutFeedback>

                <View style={{ margin: 10, width: 150, alignItems: 'center', flexDirection: 'column' }}>
                    {formatedSelectedMonth}
                </View>

                <TouchableWithoutFeedback onPress={onNextMonth}>
                    <View style={{padding: 5}}>
                        <Ionicons name="ios-arrow-forward" size={25} color="white"/>
                    </View>
                </TouchableWithoutFeedback>
            </View>
        </View>

        <View style={{height: 1, backgroundColor: '#a0ca45', marginBottom: 15}}></View>

        <View style={{marginTop: 10, marginBottom: 10}}>
            {filteredItems.length == 0 ? (
                <Text style={{fontWeight: 'bold', textAlign: 'center', color: 'white'}}>No pick up requests</Text>
            ) : filteredItems.map(props => <PickupRequestItem key={props.id}
                                                              onCancel={() => onCancelItem(props.id)} {...props}  />)}
        </View>
    </TransparentBox>
}